import Component from '../core/Component'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

export default class LocationModal extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null
        }
    }

    prepare() {
        this.slider = Component.getFromElement(this.ref.slider)
        EventBus.on(EVENTS.MODALOPENER_CLICK, this.handleModalOpenerClick)
        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    handleModalOpenerClick = data => {
        if (!document.getElementById(data.id).contains(this.element)) {
            return
        }

        const index = this.slider.getItems().findIndex(item => {
            return item.dataset.locationId === data.options.locationId
        })

        if (!~index) {
            return
        }


        this.slider.select(index)
    }

    handleModalOpen = data => {
        if (!document.getElementById(data.id).contains(this.element)) {
            return
        }
        this.slider.check()
    }
}